export default __webpack_public_path__ + "static/media/iam_m3.9bb395c2.png";